import { restore } from 'effector';
import { useUnit } from 'effector-react';
import $$api from 'models/api';
import $$auth from 'models/auth';
import $$weakPassword from 'models/change-weak-password';
import { $isAdvisorPanel } from 'models/location';
import { $global } from 'models/store-global';
import { Alert, Col, Row, Spinner, Tab } from 'react-bootstrap';
import 'react-phone-input-2/lib/bootstrap.css';

import ChangeEmail from './ChangeEmail/ChangeEmail';
import ChangePassword from './ChangePassword/ChangePassword';
import ProfileEdit from './ProfileEdit/ProfileEdit';

import useResources from 'hooks/useResources';

import { type TRole } from 'types/Store';

type AccountPageProps = {
    role?: TRole;
};

const $isModalityClosed = restore(
    $$weakPassword.modalClosed.map(() => true),
    false,
);

const AccountPage = (props: AccountPageProps) => {
    const { t } = useResources();

    const isAdvisorPanel = useUnit($isAdvisorPanel);
    const participant = useUnit($$auth.$currentParticipant);
    const isPreliminaryUser = useUnit($global.map((state) => state.isPreliminaryUser || false));
    const isPasswordChangeRequired = useUnit($$weakPassword.$changeRequired);
    const isModalityClosed = useUnit($isModalityClosed);

    const reloadData = async () => {
        await $$api.qInstances.getInstancesFx(undefined);
    };

    if (!participant) {
        return (
            <div className="container settings-page pt-4">
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (isPasswordChangeRequired && !isModalityClosed) {
        return null;
    }

    return (
        <div className="container settings-page pt-4">
            <Tab.Container defaultActiveKey="profile">
                <Row>
                    <Col md={3} lg={3}></Col>
                    <Col md={9} lg={7}>
                        <Tab.Content>
                            {isPreliminaryUser && isAdvisorPanel && (
                                <Alert show={true} variant="warning">
                                    {t('profile_edit.emptyAdvisorWarning')}
                                </Alert>
                            )}
                            <Tab.Pane eventKey="profile">
                                {!isPasswordChangeRequired && (
                                    <ProfileEdit
                                        participant={participant}
                                        disallowNameEditing={
                                            !(participant?.systemRoles || []).includes('admin') &&
                                            !!participant?.user?.plan?.subscription
                                        }
                                        role={props.role}
                                        onSave={reloadData}
                                    />
                                )}
                                <ChangePassword />
                                {!isPasswordChangeRequired && <ChangeEmail />}
                            </Tab.Pane>
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </div>
    );
};

export default AccountPage;
